<script setup lang="ts">
import { computed, reactive } from 'vue';
import {
  ZPageRenderer,
  ZTemplateRenderer,
  useCreatePageSections,
  usePageHandlersInstance,
} from '@zoomcatalog/design-templates';
import type { Page } from '@zoomcatalog/design-templates';

const props = defineProps<{
  page: Page;
  useAutoScaling: boolean;
}>();

const pageHandlers = usePageHandlersInstance();

useCreatePageSections(
  reactive({
    initialSections: props.page.settings.sections,
    locale: {
      COVER: 'Cover',
      TITLE: 'Title',
      PRODUCTS: 'Products',
      LOGOS: 'Logos',
      FOOTER: 'Footer',
      DISCLAIMER_TEXT: 'Disclaimer text',
      PAGE_SECTIONS: 'Page sections',
      FIXED_PAGE_SECTIONS: 'Fixed page sections',
      SHOW_HIDE: 'Show/Hide',
      REORDER: 'Reorder',
      FIXED_FOOTER: 'Fixed footer',
      DISABLED_ALERT:
        'Editing has been disabled for this page by the template creator.',
      ALLOW_EDITING: 'Allow editing this page',
      CAN_EDIT: 'Yes, this page can be edited.',
      TEMPLATE: 'Template',
    },
    templateKey: computed(() => props.page.templateName),
    pageId: computed(() => props.page.pageId),
    getters: {
      getPageTemplateSettings: () =>
        pageHandlers.getTemplateSettings(null, props.page),
      getPageSectionSettings: () => props.page.settings.sections,
    },
    handlers: {
      onPageTemplateSettingsChange(nextSettings) {
        pageHandlers.onTemplateSettingsChange?.({
          settings: nextSettings,

          page: props.page,
        });
      },
    },
    isSortEnabled: false,
  })
);
</script>

<template>
  <ZPageRenderer :page="page">
    <ZTemplateRenderer
      :templateName="page.templateName"
      :useAutoScaling="useAutoScaling"
    />
  </ZPageRenderer>
</template>
